import { Skeleton } from "@/components/ui/skeleton";

/** Placeholder of a task page while its first batch loads. */
export function TaskStageSkeleton() {
  return (
    <div className="mx-auto w-full max-w-3xl space-y-5 px-4 pt-6 sm:px-6" aria-busy="true">
      <div className="flex items-center gap-3">
        <Skeleton className="size-11 rounded-full bg-muted/50" />
        <Skeleton className="h-5 w-40 bg-muted/60" />
      </div>
      <Skeleton className="h-1 w-full bg-muted/40" />
      <Skeleton className="h-56 w-full rounded-xl bg-muted/40" />
      <Skeleton className="h-14 w-full rounded-xl bg-muted/30" />
    </div>
  );
}
